module.exports = __webpack_public_path__ + "img/Search Property.3a5567ab.svg";